import React from 'react';
import ProjectCard from './ProjectCard';
import { ProjectGridProps } from '../types';

const ProjectGrid = ({ projects, onProjectSelect }: ProjectGridProps) => {
  if (projects.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-24 h-24 mx-auto mb-6 bg-muted rounded-full flex items-center justify-center">
          <svg
            className="w-12 h-12 text-text-secondary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-text-primary mb-2">No Projects Found</h3>
        <p className="text-text-secondary max-w-md mx-auto">
          No projects match your current filters. Try adjusting your search criteria or clearing the filters.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onViewDetails={onProjectSelect}
        />
      ))}
    </div>
  );
};

export default ProjectGrid;